import Player from '@vimeo/player';
import {trackEvent} from "../utils/plausible";
let player;

export function componentVimeoVideo() {

    Alpine.data('videoPlayer', () => ({
        player: null,
        currentTime: 0,
        playerLoaded: false,
        in_development : (site_objects.environment === 'development'),
        is_user_logged_in : (site_objects.user_is_logged_in === 'true'),

        loadPlayer() {

            player.ready().then(() => {
                player.play();
            })

            timeupdate(player, this.$refs.vimeoPlayer, this.is_user_logged_in);
            video_ended(player, this.$refs.vimeoPlayer, this.is_user_logged_in);

            this.playerLoaded = true;

            if(this.is_lesson){
                player.on('ended', (data) => {
                    this.$dispatch('video-ended', true);
                })
            }
        },

        init() {
            this.player = new Player(this.$refs.vimeoPlayer)

            player = Alpine.raw(this.player, {
                dnt: true,
                responsive: true,
            })

            player.setColor('#C9D3FF').then().catch();
            player.setMuted(this.in_development).then().catch();
        }
    }));
}

function timeupdate(player, videoElement, is_logged_in) {

    let previousProgressPercentage = 0,
        executeEvents = [10, 50, 90];

    player.on('timeupdate', (data) => {
        let progressPercentage = Math.floor(data.percent * 100),
            event = (progressPercentage > 89) ? 'is_done' : 'in_progress';

        if (progressPercentage >= previousProgressPercentage + 10 && executeEvents.includes(progressPercentage)) {

            if (is_logged_in && videoElement.dataset.plausibleLesson) {
                update_lesson_status(videoElement.dataset.postId, event)
            }

            trackEvent('Video', {
                props: {
                    type: videoElement.dataset.plausibleType,
                    title: videoElement.dataset.plausibleTitle,
                    course: videoElement.dataset.plausibleCourse,
                    module: videoElement.dataset.plausibleModule,
                    lesson: videoElement.dataset.plausibleLesson,
                    completion: progressPercentage + '%',
                    sourceURL: 'https://player.vimeo.com/video/' + videoElement.dataset.vimeoId,
                }
            })

            previousProgressPercentage = progressPercentage
        }
    })
}

function video_ended(player, videoElement, is_logged_in) {

    player.on('ended', (data) => {

        if (is_logged_in && videoElement.dataset.plausibleLesson) {
            update_lesson_status(videoElement.dataset.postId, 'is_done')
        }

        trackEvent('video', {
            props: {
                type: videoElement.dataset.plausibleType,
                title: videoElement.dataset.plausibleTitle,
                course: videoElement.dataset.plausibleCourse,
                module: videoElement.dataset.plausibleModule,
                lesson: videoElement.dataset.plausibleLesson,
                completion: '100%',
                sourceURL: 'https://player.vimeo.com/video/' + videoElement.dataset.vimeoId,
            }
        })
    })
}

function update_lesson_status(lesson_id, event) {
    let formData = new FormData();

    formData.append('action', 'update_lesson_status');
    formData.append('lesson_id', lesson_id);
    formData.append('event', event);

    fetch(site_objects.ajax_url, {
        method: "POST",
        body: formData
    })
        .then((res) => res.json())
        .then((res) => {})
}